import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const NeighborhoodService = {
    list: async (data) => axios.post(API_URL + "/neighborhood/list", data).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_URL + `/getNeighborhood/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_URL + `/neighborhood`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (id, data) => axios.post(API_URL + `/neighborhood/${id}`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_URL + `/neighborhood/${id}`).then(({data}) => data).catch((err) => { throw err }),
    importPreview: async (data) => axios.post(API_KEEPER + "/neighborhood/import/preview", data).then(({data}) => data).catch((err) => { throw err }),
    createImport: async (data) => axios.post(API_KEEPER + "/neighborhood/import", data).then(({data}) => data).catch((err) => { throw err }),
    importTemplateUrl: () => API_KEEPER + "/neighborhood/import/template",
    neighborhoodNamesSchedule: async () => axios.get(`${API_URL}/locations/neighborhoodNamesSchedule`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    getNames: async () => axios.get(`${API_URL}/neighborhood/get/names`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default NeighborhoodService;
